/**
 * Оглавление Книги Знаний.
 *
 * Максим 22.08.2026 дал ссылку на блог в GitBook и попросил перенести
 * материалы, разбив по типам. Структура снята оттуда целиком — девять
 * разделов, около полусотни страниц.
 *
 * Пока это оглавление со ссылками на первоисточник, а не перенесённые
 * тексты. Так сделано намеренно: показать полный состав Книги можно
 * сегодня, а переписывать пятьдесят страниц — работа не на один день.
 * Человек сразу видит, что в Книге есть, и попадает на нужный материал;
 * по мере переноса ссылка у статьи меняется с внешней на внутреннюю, и
 * оглавление остаётся тем же.
 */

const GB = "https://breedy-1.gitbook.io/untitled";

export const SECTIONS = [
  {
    key: "start",
    title: "С чего начать",
    lead: "Что такое «Волшебный мир», куда он движется и как попасть в тесты.",
    kind: "Основы",
    items: [
      { title: "Приветствие", to: "/knowledge/welcome" },
      /* Перенесена в кабинет 22.08.2026. */
      { title: "Что такое «Волшебный мир»", to: "/knowledge/welcome" },
      { title: "Дорожная карта", to: "/knowledge/roadmap" },
      { title: "Бета-тесты 2.0", to: "/knowledge/beta" },
    ],
  },
  {
    key: "platform",
    title: "Платформа",
    lead: "Как устроен «Волшебный мир» и что даёт каждая из шести ролей.",
    kind: "Основы",
    items: [
      /* Перенесена в кабинет 22.08.2026 — открывается внутри. */
      { title: "Что умеет платформа", to: "/knowledge/platform" },
      /* Роли уже описаны в кабинете — на своих страницах, где рядом стоят
         кнопки действий. Вести их в блог значило бы уводить человека от
         того места, где роль можно открыть. */
      { title: "Герой", to: "/role/hero" },
      { title: "Ремесленник", to: "/role/craftsman" },
      { title: "Патронус", to: "/role/patronus" },
      { title: "Эксперт", to: "/role/expert" },
      { title: "Мастер", to: "/role/master" },
      { title: "Хранитель", to: "/role/keeper" },
    ],
  },
  {
    key: "fairyton",
    title: "Приложение FairyTON",
    lead: "Разделы приложения в Telegram: ферма, игра, квесты, друзья, магазин.",
    kind: "Продукты",
    items: [
      /* Разделы приложения собраны в одну статью: по отдельности каждый —
         полстраницы текста, а вместе получается связный обзор. */
      { title: "Обзор приложения", to: "/knowledge/fairyton" },
      { title: "Home — прогресс и доход", to: "/knowledge/fairyton" },
      { title: "Farm — оранжерея и фарминг", to: "/knowledge/fairyton" },
      { title: "Game", to: "/knowledge/fairyton" },
      { title: "Quest — задания", to: "/knowledge/fairyton" },
      { title: "Friends", to: "/knowledge/fairyton" },
      { title: "Store", to: "/knowledge/fairyton" },
      { title: "AI-помощник", to: "/knowledge/fairyton" },
    ],
  },
  {
    key: "fairyland",
    title: "Метавселенная FairyLand",
    lead: "Сюжетный мир: главы, локации и мастерские.",
    kind: "Продукты",
    items: [
      { title: "Вступление", to: "/knowledge/fairyland" },
      { title: "Добро пожаловать в Волшебный Мир", to: "/knowledge/fairyland" },
      { title: "Первая глава", to: "/knowledge/fairyland" },
      { title: "Ювелирная мастерская", to: "/knowledge/rings" },
    ],
  },
  {
    key: "ar",
    title: "Геймификация и AR",
    lead: "Как реальные пространства превращаются в игру. С описанием пакетов.",
    kind: "Продукты",
    items: [
      { title: "Коротко о геймификации", to: "/knowledge/gamification" },
      { title: "Подробное описание", to: "/knowledge/gamification" },
      { title: "Велком-квест", to: "/knowledge/gamification" },
      { title: "Пакет «Старт»", to: "/knowledge/gamification" },
    ],
  },
  {
    key: "cases",
    title: "Кейсы",
    lead: "Двенадцать реализованных проектов — от Парка Горького до Бурятии.",
    kind: "Кейсы",
    items: [
      /* Шесть кейсов сведены в одну статью в кабинете — читать подряд удобнее,
         чем открывать шесть страниц. Остальные шесть пока в блоге. */
      { title: "Шесть проектов, которые уже работают", to: "/knowledge/cases" },
      { title: "Музеон (Парк Горького)", to: "/knowledge/cases" },
      { title: "Смешарики", to: "/knowledge/cases" },
      { title: "Лукоморье", to: "/knowledge/cases" },
      { title: "Парк «Сказка»", to: "/knowledge/cases" },
      { title: "Тальцы", to: "/knowledge/cases" },
      { title: "DDX Фестиваль", to: "/knowledge/cases" },
      { title: "РусАл Саяногорск", to: "/knowledge/cases" },
      { title: "Мастер Дракона", to: "/knowledge/cases" },
      { title: "Робототехника", to: "/knowledge/cases" },
      { title: "Go 360", to: "/knowledge/cases" },
      { title: "Сокровища Грузии", to: "/knowledge/cases" },
      { title: "Бурятия, Аршан", href: `${GB}/geimifikaciya-ar-game/keisy-geimifikacii/buryatiya-arshan` },
    ],
  },
  {
    key: "services",
    title: "Услуги",
    lead: "Что команда делает на заказ: разработка, AI, продакшен, трафик.",
    kind: "Бизнес",
    items: [
      { title: "Интеграция AI в бизнес", to: "/knowledge/services" },
      { title: "AI-видеопродакшен", to: "/knowledge/services" },
      { title: "Цифровые аватары", to: "/knowledge/services" },
      { title: "Визуальная упаковка", to: "/knowledge/services" },
      { title: "Маркетинг 3.0", to: "/knowledge/services" },
      { title: "Трафик", to: "/knowledge/services" },
    ],
  },
  {
    key: "business",
    title: "AR-бизнес и экономика",
    lead: "Как на этом зарабатывают: модель, валюты, распределение дохода.",
    kind: "Бизнес",
    items: [
      { title: "AR-бизнес", to: "/knowledge/arbusiness" },
      { title: "Экономика", to: "/knowledge/economy" },
    ],
  },
  {
    key: "learning",
    title: "Образовательные курсы",
    lead: "Обучение платформе. Первые уроки уже открыты в кабинете.",
    kind: "Обучение",
    items: [
      { title: "Образовательные курсы", to: "/knowledge/courses" },
      { title: "Как устроена платформа — урок в кабинете", to: "/learning/structure" },
    ],
  },
];

/** Типы для фильтра: порядок задан вручную — от общего к прикладному. */
export const KINDS = ["Основы", "Продукты", "Кейсы", "Бизнес", "Обучение"];

export const countItems = () =>
  SECTIONS.reduce((sum, s) => sum + s.items.length, 0);
